/**
 * Centralized App Registry
 *
 * Single source of truth for all app/tenant identifiers used across the monorepo.
 * Add new apps here — sidebar nav, dropdowns, filters, and API schemas
 * all derive from this registry.
 */
// ── Registry ───────────────────────────────────────────────
/**
 * All known apps. Order here determines order in dropdowns and sidebar.
 */
export const APP_REGISTRY = [
    {
        id: 'play',
        label: 'Play',
        icon: '▶',
        badgeClass: 'bg-blue-100 text-blue-700',
    },
    {
        id: 'skylrk',
        label: 'Skylrk',
        icon: '🎵',
        badgeClass: 'bg-pink-100 text-pink-700',
    },
];
/**
 * The "both" meta-option for collections published to all apps.
 */
export const APP_BOTH = {
    id: 'both',
    label: 'Both',
    icon: '✦',
    badgeClass: 'bg-purple-100 text-purple-700',
};
// ── Derived helpers ────────────────────────────────────────
/** All real app IDs (no "both") */
export const APP_IDS = APP_REGISTRY.map((a) => a.id);
/** All app IDs including "both" */
export const APP_IDS_WITH_BOTH = [...APP_IDS, APP_BOTH.id];
/** Quick lookup: id → AppDefinition */
export const APP_BY_ID = Object.fromEntries([
    ...APP_REGISTRY.map((a) => [a.id, a]),
    [APP_BOTH.id, APP_BOTH],
]);
/** Default app ID (used for DB defaults, env fallbacks, etc.) */
export const DEFAULT_APP_ID = APP_REGISTRY[0].id; // 'play'
/** Shorthand constants for code that references specific apps */
export const APP_ID_PLAY = 'play';
export const APP_ID_SKYLRK = 'skylrk';
export const APP_ID_BOTH = 'both';
